import { Clip } from '@ff-os/rendering-shared/Clip';
import { Spaces } from '@ff-os/rendering-shared/coordinates';
import { Size } from '@ff-os/shared-utils/types/Size';
import { Pipeline } from 'ff-canvas';

export const applyPreviewClipToDesignArea = (
    canvas: HTMLCanvasElement,
    previewClip: Clip,
    spaces: Spaces,
    pipeline: Pipeline
) => {

    const ctx = canvas.getContext('2d')!;

    ctx.save();
    ctx.globalCompositeOperation = 'destination-in';

    const canvasSize = {
        width: canvas.width / pipeline.device.pixelRatio,
        height: canvas.height / pipeline.device.pixelRatio
    };

    const designAreaSizeInPx = {
        width: canvasSize.width * (spaces.designAreaWidth / spaces.sceneWidth),
        height: canvasSize.height * (spaces.designAreaHeight / spaces.sceneHeight)
    };

    const scale = scaleToDesignArea(designAreaSizeInPx, previewClip);
    const offset = translateToDesignArea(designAreaSizeInPx, canvasSize);

    for (const path of previewClip.paths) {
        ctx.translate(offset.x, offset.y);
        ctx.scale(scale.x, scale.y);
        ctx.fill(new Path2D(path));
    }

    ctx.restore();
};

const scaleToDesignArea = (designAreaInPx: Size, clip: Clip) => ({
    x: designAreaInPx.width / clip.width,
    y: designAreaInPx.height / clip.height
});

const translateToDesignArea = (designAreaInPx: Size, canvasSize: Size) => ({
    x: 0.5 * (canvasSize.width - designAreaInPx.width),
    y: 0.5 * (canvasSize.height - designAreaInPx.height)
});